// extracted by mini-css-extract-plugin
export default {"container":"BackButton_container__jUa6A","text":"BackButton_text__Jgl3I","arrowContainer":"BackButton_arrowContainer__OUmkB","leftArrow":"BackButton_leftArrow__WpGiL"};